import {getStudyCoordinator, IGetStudyCoordinatorResponse} from 'core/api/study_coordinator'
import {IAction} from 'core/store'
import {Reducer} from 'redux'
import {all, call, put, takeLatest} from 'redux-saga/effects'
import {actions as mainActions} from 'study_coordinator/store/main'
import {setInstitution} from './institution'

const SET_IS_FETCHING = 'study-coordinator/SET_IS_FETCHING'
const RESET_IS_FETCHING = 'study-coordinator/RESET_IS_FETCHING'

interface IActionSetIsFetching extends IAction<typeof SET_IS_FETCHING> {}
interface IActionResetIsFetching extends IAction<typeof RESET_IS_FETCHING> {}

export const setIsFetching = (): IActionSetIsFetching => ({
  type: SET_IS_FETCHING,
})
export const resetIsFetching = (): IActionResetIsFetching => ({
  type: RESET_IS_FETCHING,
})

export type IState = boolean

const initialState: IState = false

type TAction = IActionSetIsFetching | IActionResetIsFetching

export const reducer: Reducer<IState> = (state: IState = initialState, action: TAction): IState => {
  switch (action.type) {
    case SET_IS_FETCHING:
      return true
    case RESET_IS_FETCHING:
      return false
    default:
      return state
  }
}

const GET_STUDY_COORDINATOR_REQUEST = 'study-coordinator/GET_STUDY_COORDINATOR_REQUEST'

interface IActionGetStudyCoordinatorRequest extends IAction<typeof GET_STUDY_COORDINATOR_REQUEST> {}

export const getStudyCoordinatorRequest = (): IActionGetStudyCoordinatorRequest => ({
  type: GET_STUDY_COORDINATOR_REQUEST,
})

export interface IDependencies {
  withAuth: (fn: (...args: any[]) => any) => void
  onTokenExpired: () => void
}

export function* getStudyCoordinatorSaga(dependencies: IDependencies, action: IActionGetStudyCoordinatorRequest) {
  yield put(setIsFetching())
  const response: IGetStudyCoordinatorResponse = yield call(
    dependencies.withAuth,
    getStudyCoordinator,
  )
  if (response.status === 200) {
    yield put(setInstitution(response.data.studyInstitution))
  } else if (response.status === 401) {
    yield call(dependencies.onTokenExpired)
  } else {
    yield put(mainActions.snackbarSetRequest(
      'Uh oh! Something went wrong. Please refresh the page or try again later.',
    ))
  }

  yield put(resetIsFetching())
}

export function* saga(dependencies: IDependencies) {
  yield all([
    takeLatest(GET_STUDY_COORDINATOR_REQUEST, getStudyCoordinatorSaga, dependencies),
  ])
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_coordinator/src/store/study-coordinator/request.ts